import ReincorporationRepository from '../../domain/repositories/ReincorporationRepository';
import ReincorporationDataStore from '../datastores/ReincorporationDataStore';
import ReincorporationDataStoreFactory from '../factories/ReincorporationDataStoreFactory';

export default class ReincorporationDataRepository
  implements ReincorporationRepository
{
  programByCampus(campusId: string, periodId: string) {
    const reincorporationDataStore: ReincorporationDataStore =
      ReincorporationDataStoreFactory.create();

    return reincorporationDataStore.programByCampus(campusId, periodId);
  }

  registerReincorporation(request: any) {
    const reincorporationDataStore: ReincorporationDataStore =
      ReincorporationDataStoreFactory.create();
    return reincorporationDataStore.registerReincorporation(request);
  }

  activatePaymentReincorporation(
    procedureId: number,
    requestId: number,
    deliveryMode: string,
    career: string
  ) {
    const reincorporationDataStore: ReincorporationDataStore =
      ReincorporationDataStoreFactory.create();
    return reincorporationDataStore.activatePaymentReincorporation(
      procedureId,
      requestId,
      deliveryMode,
      career
    );
  }
}
